import type { Router } from 'vue-router'
import { defineNuxtPlugin } from '#app'
import { useBootstrapSession } from '~/domain/shared/authentication/composables/useBootstrapSession'
import { waitForAuthStoreHydration } from '~/domain/shared/authentication/composables/ensurePersistedAuthState'

export default defineNuxtPlugin(async (nuxtApp) => {
  const router = nuxtApp.$router as Router

  await waitForAuthStoreHydration()
  await useBootstrapSession(router.currentRoute.value)
})
